import { useRef, useEffect, useState } from "react";
import { Autocomplete } from "@react-google-maps/api";

/**
 * @typedef  {Object} PlaceAutocompleteProps
 * @property {google.maps.places.ComponentRestrictions} [restrictions] - Optional restrictions on autocomplete results.
 * @property {string} [inputId] - Optional input id to assign to the input element.
 * @property {string[]} [types] - Optional types of predictions (e.g., 'geocode', 'address').
 * @property {string[]} [fields] - Fields to be returned for a PlaceResult.
 * @property {(place: google.maps.places.PlaceResult | null, query?: string) => void} [onPlaceSelected] - Callback when a place is selected.
 * @property {string} [placeholder] - Placeholder text for the input field.
 * @property {string} [className] - CSS class for styling the input field.
 * @property {boolean} [disabled] - Boolean to disable the input field.
 */

/**
 * PlaceAutocomplete component for Google Places API Autocomplete
 * @param {PlaceAutocompleteProps} props 
 */
const PlaceAutocomplete = ({
    restrictions,
    types,
    fields,
    onPlaceSelected,
    className,
    placeholder,
    disabled,
    inputId = "autocomplete-input",
    containerElement
}) => {
    const autocomplete = useRef(null); // Reference to store the autocomplete instance
    const inputRef = useRef(null);     // Reference to store the input element

    // uncomment if we decide to use ip to render closest cities etc
    // const [ip, setIp] = useState('');

    // useEffect(() => {
    //     axios.get('https://api.ipify.org?format=json')
    //       .then(response => {
    //         setIp(response.data.ip);
    //         console.log("ipp ",response.data.ip);
    //       })
    //       .catch(error => {
    //         console.error("There was an error fetching the IP address!", error);
    //       });
    //   }, []);

    /**
     * Handle place selection from the autocomplete dropdown.
     */
    const handlePlaceSelect = () => {
        if (autocomplete.current && onPlaceSelected) {
            const place = autocomplete.current.getPlace(); // Get the selected place
            if (inputRef.current) {
                onPlaceSelected(place);
            }
        }
    };

    return (
        <Autocomplete
            restrictions={restrictions} // Set the restrictions on the autocomplete
            fields={fields}             // Specify the fields to return from the autocomplete result
            types={types}               // Specify the types of predictions to return
            onLoad={(autocompleteInstance) => (autocomplete.current = autocompleteInstance)} // Store the loaded autocomplete instance
            // options={{
            //     locationBias: { "IP_BIAS": "ip" }
                
            // }} 
            onPlaceChanged={handlePlaceSelect} // Handle the event when a place is selected
            containerElement={containerElement}
        >
            <input
                id={inputId}
                ref={inputRef}           // Reference to the input element
                disabled={disabled}      // Disable the input if `disabled` is true
                type="text"              // Set the input type to text
                placeholder={placeholder} // Set the placeholder text
                className={className}     // Apply the passed class name for styling
            />
        </Autocomplete>
    );
};

export default PlaceAutocomplete;
